import styled from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const EventInfoWrapper = styled.div<IWithSize>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: ${({ size }) => (size ? 15 * size : 15)}px;
`

export default EventInfoWrapper
